import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { WixConnect } from 'shared/utils/wix-connect';

import NavArrow from './images/prev.svg';

import styles from './nav-button.styl';

import sharedTranslations from 'shared/translations/navigation';


@WixConnect(styles)
class GenericNavButton extends React.Component {

  static propTypes = {
    name: React.PropTypes.string.isRequired,
    onClick: React.PropTypes.func,
    disabled: React.PropTypes.bool,
  };

  static defaultProps = {
    rounded: false,
  };

  @autobind
  handleClick() {
    const { disabled, onClick } = this.props;
    if (!disabled) {
      return onClick();
    }
  }

  render() {
    const { name, disabled } = this.props;

    const styleNames = classnames('nav-button', name, {
      disabled,
    });

    return (
      <button onClick={this.handleClick}
              styleName={styleNames}>
        <NavArrow styleName="nav-arrow" />
        <div styleName="nav-text">
          <FormattedMessage {...sharedTranslations[name]} />
        </div>
      </button>
    );
  }
}


export function PrevButton(props) {
  return (
    <GenericNavButton {...props}
                      name="prev" />
  );
}

export function NextButton(props) {
  return (
    <GenericNavButton {...props}
                      name="next" />
  );
}



// WEBPACK FOOTER //
// ./src/widget/components/videos-list/nav-button/nav-button.js